import "./SidePanel.css";

export default function SidePanel({
  open,
  onClose,
  width = 360,
  title,
  children
}) {
  if (!open) return null;

  return (
    <div className="side-panel-overlay" onClick={onClose}>
      <div
        className="side-panel"
        style={{ width }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="side-panel-header">
          <h5 className="mb-0">{title}</h5>
          <button className="btn-close" onClick={onClose} />
        </div>

        <div className="side-panel-body">
          {children}
        </div>
      </div>
    </div>
  );
}
